import React from 'react';
import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';

const FeatureShops = ({ shops }) => {
  // Utility function to format shop name
  const formatShopName = (shopName) => {
    if (!shopName) return 'unnamed-shop'; // Handle missing shop names
    return shopName.toLowerCase().replace(/\s+/g, '-'); // Convert to lowercase and replace spaces with hyphens
  };

  return (
    <div className="w-[85%] flex flex-wrap mx-auto">
      <div className="w-full">
        <div className="text-[18px] flex items-center justify-between text-gray-900 font-bold relative pb-[45px]">
          <h2>Featured stores</h2>
          <Link to="stores" className="">
            <p>See all</p>
          </Link>
        </div>
      </div>
      <div className="w-full grid grid-cols-4 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-6">
        {shops.map((shop, i) => (
          <div
            key={i}
            className="bg-white border border-gray-100 group transition-all duration-500 hover:shadow-md cursor-pointer"
          >
            <div className="relative overflow-hidden">
              {shop.shopInfo?.verified && (
                <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-green-600 font-semibold text-s left-2 top-2">
                  Verified
                </div>
              )}
              <Link
                to={`/stores/${formatShopName(shop.shopInfo.shopName)}/${shop._id}`}
                className=""
              >
                <img
                  className="sm:w-full w-full h-[240px] nex_img_cover"
                  src={shop.image || '/default-shop-image.png'}
                  alt={`${shop.shopInfo?.shopName || 'Shop'} store`}
                />
              </Link>
            </div>
            <div className="py-3 text-slate-white px-2">
              <div className="flex justify-between items-center gap-3 p-2">
                <h2 className="text-lg font-bold">
                  {shop.shopInfo?.shopName || 'Unnamed Shop'}
                </h2>
                <div className="flex items-center">
                  <Package size={18} className="mr-1" />
                  <span>{shop.productCount || 0}</span>
                </div>
              </div>
              <div className="p-2 text-gray-300">
                {shop.shopInfo?.description?.length > 100
                  ? `${shop.shopInfo.description.slice(0, 100)}...`
                  : shop.shopInfo?.description || 'No description available.'}
              </div>
              <div className="p-2">
                <Link
                  to={`/stores/${formatShopName(shop.shopInfo.shopName)}/${shop._id}`}
                  className="w-full justify-center flex items-center nex_button_main font-semibold border border-gray-200 hover:bg-[#FFE11B] hover:border-[#FFE11B] hover:text-black py-2"
                >
                  Visit store
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureShops;
